import React, { Component } from 'react'
import { AlphanumericInputWithMask, FieldGroup } from '@lmig/lmds-react'

class Address1 extends Component {
  state = {
    ht: 'error',
    val: undefined,
  }
  handleFormChange = event => {
    let inputValue = event.target.value
    if (inputValue.length > 0) {
      this.setState({ ht: undefined })
    } else {
      this.setState({ ht: 'error' })
    }
  }
  render() {
    const { onChangeValue } = this.props
    const regex = /^[^*|":<>[\]{}`\\;@$%!]+$/
    return (
      <FieldGroup
        id='fieldgroup--address1'
        disableMargins='top'
        isFull
        messages={[
          {
            text: 'Required',
            type: 'error',
          },
        ]}
      >
        <AlphanumericInputWithMask
          name='address1'
          highlightType={this.state.ht}
          id='Alphanumeric--address1'
          labelVisual='Address 1'
          labelA11y='Address 1'
          mask={{mask: regex}}
          onChange={function (e) {
            onChangeValue(e)
            this.handleFormChange(e)
          }.bind(this)}
        />
      </FieldGroup>
    )
  }
}

export default Address1
